import {useState} from "react";
import moment from "moment/moment";
// -
import useCustomTranslation from "core/customTranslation";



const translations = {
    es: {
        dayStart: "Dia de inicio de recuperación"
    },
    en: {
        dayStart: "Day start of recovery"
    }
};
const MiniQForm = () => {
    const {t: _TC} = useCustomTranslation(translations);
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
    });

    const selectDateRange = (e) => {
        const {value} = e.target;
        const dateRange_ = moment(value);

        setDateRange({
            startDate: dateRange_.clone().startOf("day"),
            endDate: dateRange_.clone().endOf("day"),
        });
    };

    return (
        <div className="row">
            <div className="col-12">
                <h2 className="text-center mt-5">
                    {_TC("dayStart")}
                </h2>
                <div className="d-flex justify-content-center mt-4">
                    <div
                        className="col mb-3 me-2 text-center"
                        style={{maxWidth: "170px"}}
                    >
                        <label htmlFor="start" className="form-label">
                            Seleccionar día
                        </label>
                        <input
                            // type="datetime-local"
                            type="date"
                            className="form-control"
                            id="start"
                            name="start"
                            value={dateRange.startDate.format(
                                // "YYYY-MM-DDTHH:mm"
                                "YYYY-MM-DD"
                            )}
                            onChange={selectDateRange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

}
export default MiniQForm;